/*
 * This file is a generated Typescript file for GRPC Gateway, DO NOT MODIFY
 */

import * as fm from "../../../fm"


/**
 * Сервис работы со справочниками атрибутов камер
 */

/**
 * Сервис работы со справочниками атрибутов камер
 */
export class DictionaryServiceClient {
  /**
   * Конструктор сервиса
   * @param host Адрес хоста
   * @param token Токен доступа
   */
  constructor(
    public host = "",
    public token = ""
  ) { }

  /**
   * Метод получения справочника категорий.
   * Метод доступен для: admin, service, bti, owner, employee
   */
  GetDictionaryCategories = (req?: GetDictionaryCategoriesRequestDto, init?: RequestInit): Promise<GetDictionaryCategoriesResponseDto> => {
    return fm.request<GetDictionaryCategoriesRequestDto, GetDictionaryCategoriesResponseDto>(`${this.host}/vc/api/v1/dictionary/categories${fm.buildQuery(req)}`, { ...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод получения справочника тарифов.
   * Метод доступен для: admin, service, bti, owner, employee
   */
  GetDictionaryTariffs = (req?: GetDictionaryTariffsRequestDto, init?: RequestInit): Promise<GetDictionaryTariffsResponseDto> => {
    return fm.request<GetDictionaryTariffsRequestDto, GetDictionaryTariffsResponseDto>(`${this.host}/vc/api/v1/dictionary/tariffs${fm.buildQuery(req)}`, { ...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод получения справочника ролей.
   * Метод доступен для: admin, service, bti, owner, employee
   */
  GetDictionaryRoles = (req?: GetDictionaryRolesRequestDto, init?: RequestInit): Promise<GetDictionaryRolesResponseDto> => {
    return fm.request<GetDictionaryRolesRequestDto, GetDictionaryRolesResponseDto>(`${this.host}/vc/api/v1/dictionary/roles${fm.buildQuery(req)}`, { ...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

}

/**
 * Категория
 */
export type CategoryRequestDto = {
  /**
   * Идентификатор
   */
  id?: number
  /**
   * Наименование
   */
  title?: string
  /**
   * Тип
   */
  kind?: string
}
/**
 * Категория
 */
export type CategoryResponseDto = {
  /**
   * Идентификатор
   */
  id: number
  /**
   * Наименование
   */
  title: string
  /**
   * Тип
   */
  kind: string
}
/**
 * Запрос на получение справочника категорий
 */
export type GetDictionaryCategoriesRequestDto = {
}
/**
 * Ответ на запрос получения справочника категорий
 */
export type GetDictionaryCategoriesResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Список категорий
   */
  readonly data: GetDictionaryCategoriesResponseCameraCategoriesDto
  /**
   * Ошибка
   */
  readonly error: GetDictionaryCategoriesResponseErrorDto
}>
/**
 * Список категорий
 */
export type GetDictionaryCategoriesResponseCameraCategoriesDto = {
  /**
   * Категория
   */
  category: CategoryResponseDto[]
}
/**
 * Ошибка запроса
 */
export type GetDictionaryCategoriesResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OptionalOneOf<{
  /**
   * Ошибка VCfront
   */
  readonly vcDictionaryError: VcDictionaryErrorRequestDto
}>
/**
 * Ошибка запроса
 */
export type GetDictionaryCategoriesResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка VCfront
   */
  readonly vcDictionaryError: VcDictionaryErrorResponseDto
}>
/**
 * Запрос на получение справочника ролей
 */
export type GetDictionaryRolesRequestDto = {
}
/**
 * Ответ на запрос получения справочника ролей
 */
export type GetDictionaryRolesResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Список ролей
   */
  readonly data: GetDictionaryRolesResponseRolesDto
  /**
   * Ошибка
   */
  readonly error: GetDictionaryRolesResponseErrorDto
}>
/**
 * Ошибка запроса
 */
export type GetDictionaryRolesResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OptionalOneOf<{
  /**
   * Ошибка VCfront
   */
  readonly vcDictionaryError: VcDictionaryErrorRequestDto
}>
/**
 * Ошибка запроса
 */
export type GetDictionaryRolesResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка VCfront
   */
  readonly vcDictionaryError: VcDictionaryErrorResponseDto
}>
/**
 * Список ролей
 */
export type GetDictionaryRolesResponseRolesDto = {
  /**
   * Роли
   */
  roles: RoleResponseDto[]
}
/**
 * Запрос на получение справочника тарифов
 */
export type GetDictionaryTariffsRequestDto = {
}
/**
 * Ответ на запрос получения справочника тарифов
 */
export type GetDictionaryTariffsResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Список тарифов
   */
  readonly data: GetDictionaryTariffsResponseCameraTariffsDto
  /**
   * Ошибка
   */
  readonly error: GetDictionaryTariffsResponseErrorDto
}>
/**
 * Список тарифов
 */
export type GetDictionaryTariffsResponseCameraTariffsDto = {
  /**
   * Тариф
   */
  tariff: TariffResponseDto[]
}
/**
 * Ошибка запроса
 */
export type GetDictionaryTariffsResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OptionalOneOf<{
  /**
   * Ошибка VCfront
   */
  readonly vcDictionaryError: VcDictionaryErrorRequestDto
}>
/**
 * Ошибка запроса
 */
export type GetDictionaryTariffsResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка VCfront
   */
  readonly vcDictionaryError: VcDictionaryErrorResponseDto
}>
/**
 * Роль
 */
export type RoleRequestDto = {
  /**
   * Идентификатор
   */
  id?: number
  /**
   * Наименование
   */
  title?: string
  /**
   * Доступы
   */
  permissions?: string[]
  /**
   * Является ли роль глобальной
   */
  isGlobal?: boolean
}
/**
 * Роль
 */
export type RoleResponseDto = {
  /**
   * Идентификатор
   */
  id: number
  /**
   * Наименование
   */
  title: string
  /**
   * Доступы
   */
  permissions: string[]
  /**
   * Является ли роль глобальной
   */
  isGlobal: boolean
}
/**
 * Тариф
 */
export type TariffRequestDto = {
  /**
   * Идентификатор
   */
  id?: number
  /**
   * Наименование
   */
  title?: string
  /**
   * Параметр slug
   */
  slug?: string
  /**
   * Тип статуса
   */
  statusKind?: string
  /**
   * Дата действия от.
   * # Тип: DateTime
   */
  fromAt?: string | null
  /**
   * Дата действия до.
   * # Тип: DateTime
   */
  toAt?: string | null
}
/**
 * Тариф
 */
export type TariffResponseDto = {
  /**
   * Идентификатор
   */
  id: number
  /**
   * Наименование
   */
  title: string
  /**
   * Параметр slug
   */
  slug: string
  /**
   * Тип статуса
   */
  statusKind: string
  /**
   * Дата действия от.
   * # Тип: DateTime
   */
  fromAt: string | null
  /**
   * Дата действия до.
   * # Тип: DateTime
   */
  toAt: string | null
}
/**
 * Ошибка VCfront
 */
export type VcDictionaryErrorRequestDto = {
  /**
   * Сервис
   */
  service?: string
  /**
   * Продукт
   */
  product?: string
  /**
   * Сообщение
   */
  message?: string
  /**
   * Причины
   */
  reasons?: VcDictionaryErrorReasonRequestDto[]
}
/**
 * Ошибка VCfront
 */
export type VcDictionaryErrorResponseDto = {
  /**
   * Сервис
   */
  service: string
  /**
   * Продукт
   */
  product: string
  /**
   * Сообщение
   */
  message: string
  /**
   * Причины
   */
  reasons: VcDictionaryErrorReasonResponseDto[]
}
/**
 * Причина
 */
export type VcDictionaryErrorReasonRequestDto = {
  /**
   * Сообщение
   */
  message?: string
}
/**
 * Причина
 */
export type VcDictionaryErrorReasonResponseDto = {
  /**
   * Сообщение
   */
  message: string
}
/**
 * Дескриптор
 */
export const descriptor = {
  /**
   * Категория
   */
  "Category": {
    "kind": "class",
    "text": "Категория",
    "fields": {
      /**
       * Идентификатор
       */
      "id": {
        "type": "int32",
        "text": "Идентификатор",
      },
      /**
       * Наименование
       */
      "title": {
        "type": "string",
        "text": "Наименование",
      },
      /**
       * Тип
       */
      "kind": {
        "type": "string",
        "text": "Тип",
      },
    },
  },
  /**
   * Запрос на получение справочника категорий
   */
  "GetDictionaryCategoriesRequest": {
    "kind": "class",
    "text": "Запрос на получение справочника категорий",
  },
  /**
   * Ответ на запрос получения справочника категорий
   */
  "GetDictionaryCategoriesResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения справочника категорий",
    "fields": {
      /**
       * Список категорий
       */
      "data": {
        "type": "GetDictionaryCategoriesResponse.CameraCategories",
        "text": "Список категорий",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "GetDictionaryCategoriesResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Список категорий
   */
  "GetDictionaryCategoriesResponse.CameraCategories": {
    "kind": "class",
    "text": "Список категорий",
    "fields": {
      /**
       * Категория
       */
      "category": {
        "type": "Category",
        "text": "Категория",
      },
    },
  },
  /**
   * Ошибка запроса
   */
  "GetDictionaryCategoriesResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса",
    "fields": {
      /**
       * Ошибка VCfront
       */
      "vcDictionaryError": {
        "type": "VcDictionaryError",
        "text": "Ошибка VCfront",
      },
    },
  },
  /**
   * Запрос на получение справочника ролей
   */
  "GetDictionaryRolesRequest": {
    "kind": "class",
    "text": "Запрос на получение справочника ролей",
  },
  /**
   * Ответ на запрос получения справочника ролей
   */
  "GetDictionaryRolesResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения справочника ролей",
    "fields": {
      /**
       * Список ролей
       */
      "data": {
        "type": "GetDictionaryRolesResponse.Roles",
        "text": "Список ролей",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "GetDictionaryRolesResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса
   */
  "GetDictionaryRolesResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса",
    "fields": {
      /**
       * Ошибка VCfront
       */
      "vcDictionaryError": {
        "type": "VcDictionaryError",
        "text": "Ошибка VCfront",
      },
    },
  },
  /**
   * Список ролей
   */
  "GetDictionaryRolesResponse.Roles": {
    "kind": "class",
    "text": "Список ролей",
    "fields": {
      /**
       * Роли
       */
      "roles": {
        "type": "Role",
        "text": "Роли",
      },
    },
  },
  /**
   * Запрос на получение справочника тарифов
   */
  "GetDictionaryTariffsRequest": {
    "kind": "class",
    "text": "Запрос на получение справочника тарифов",
  },
  /**
   * Ответ на запрос получения справочника тарифов
   */
  "GetDictionaryTariffsResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения справочника тарифов",
    "fields": {
      /**
       * Список тарифов
       */
      "data": {
        "type": "GetDictionaryTariffsResponse.CameraTariffs",
        "text": "Список тарифов",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "GetDictionaryTariffsResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Список тарифов
   */
  "GetDictionaryTariffsResponse.CameraTariffs": {
    "kind": "class",
    "text": "Список тарифов",
    "fields": {
      /**
       * Тариф
       */
      "tariff": {
        "type": "Tariff",
        "text": "Тариф",
      },
    },
  },
  /**
   * Ошибка запроса
   */
  "GetDictionaryTariffsResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса",
    "fields": {
      /**
       * Ошибка VCfront
       */
      "vcDictionaryError": {
        "type": "VcDictionaryError",
        "text": "Ошибка VCfront",
      },
    },
  },
  /**
   * Роль
   */
  "Role": {
    "kind": "class",
    "text": "Роль",
    "fields": {
      /**
       * Идентификатор
       */
      "id": {
        "type": "int32",
        "text": "Идентификатор",
      },
      /**
       * Наименование
       */
      "title": {
        "type": "string",
        "text": "Наименование",
      },
      /**
       * Доступы
       */
      "permissions": {
        "type": "string",
        "text": "Доступы",
      },
      /**
       * Является ли роль глобальной
       */
      "isGlobal": {
        "type": "bool",
        "text": "Является ли роль глобальной",
      },
    },
  },
  /**
   * Тариф
   */
  "Tariff": {
    "kind": "class",
    "text": "Тариф",
    "fields": {
      /**
       * Идентификатор
       */
      "id": {
        "type": "int32",
        "text": "Идентификатор",
      },
      /**
       * Наименование
       */
      "title": {
        "type": "string",
        "text": "Наименование",
      },
      /**
       * Параметр slug
       */
      "slug": {
        "type": "string",
        "text": "Параметр slug",
      },
      /**
       * Тип статуса
       */
      "statusKind": {
        "type": "string",
        "text": "Тип статуса",
      },
      /**
       * Дата действия от.
       * # Тип: DateTime
       */
      "fromAt": {
        "type": "google.protobuf.Timestamp",
        "text": "Дата действия от.\n# Тип: DateTime",
      },
      /**
       * Дата действия до.
       * # Тип: DateTime
       */
      "toAt": {
        "type": "google.protobuf.Timestamp",
        "text": "Дата действия до.\n# Тип: DateTime",
      },
    },
  },
  /**
   * Ошибка VCfront
   */
  "VcDictionaryError": {
    "kind": "class",
    "text": "Ошибка VCfront",
    "fields": {
      /**
       * Сервис
       */
      "service": {
        "type": "string",
        "text": "Сервис",
      },
      /**
       * Продукт
       */
      "product": {
        "type": "string",
        "text": "Продукт",
      },
      /**
       * Сообщение
       */
      "message": {
        "type": "string",
        "text": "Сообщение",
      },
      /**
       * Причины
       */
      "reasons": {
        "type": "VcDictionaryError.Reason",
        "text": "Причины",
      },
    },
  },
  /**
   * Причина
   */
  "VcDictionaryError.Reason": {
    "kind": "class",
    "text": "Причина",
    "fields": {
      /**
       * Сообщение
       */
      "message": {
        "type": "string",
        "text": "Сообщение",
      },
    },
  },
}